import {Button, Spinner} from 'react-bootstrap';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import './system.css';
import {useState} from 'react';

export const Action = ({
  children,
  href = undefined,
  onClick,
  className = '',
  disabled = false,
  outline = false,
  square = false,
}) => (
  <Button
    disabled={disabled}
    className={className ? className : undefined}
    style={{
      backgroundColor: outline ? 'transparent' : '#04bbaf',
      borderColor: '#04bbaf',
      color: outline ? '#04bbaf' : '#ffffff',
      borderRadius: square ? '0' : undefined,
    }}
    onClick={onClick}
    href={href}
  >
    {children}
  </Button>
);
export const ActionDisabled = ({children, href, onClick}) => (
  <Button
    style={{backgroundColor: '#04bbaf', borderColor: '#04bbaf'}}
    onClick={onClick}
    href={href}
    disabled={true}
  >
    {children}
  </Button>
);
export const ActionLink = ({children, to, style = {}}) => (
  <Link
    className="btn btn-success"
    style={{backgroundColor: '#04bbaf', borderColor: '#04bbaf', ...style}}
    to={to}
  >
    {children}
  </Link>
);
export const ActionHref = ({
  children,
  href,
  blank = false,
  className = null,
}) => (
  <Button
    style={{backgroundColor: '#04bbaf', borderColor: '#04bbaf'}}
    href={href}
    target={blank ? '_blank' : ''}
    className={className}
  >
    {children}
  </Button>
);
export const Secondary = ({
  children,
  href = null,
  onClick,
  disabled = false,
  style = {},
}) => (
  <Button
    disabled={disabled}
    style={{
      ...style,
      backgroundColor: '#222',
      borderColor: '#222',
    }}
    onClick={onClick}
    href={href}
  >
    {children}
  </Button>
);
export const Help = ({
  children,
  href = null,
  onClick,
  className = '',
  disabled = false,
}) => (
  <Button
    className={className}
    variant={'outline-info'}
    onClick={onClick}
    href={href}
    disabled={disabled}
  >
    {children}
  </Button>
);

export const Trash = ({onClick}) => (
  <FontAwesomeIcon
    className={'fa-trash-hovered'}
    icon={faTrashAlt}
    style={{backgroundColor: '#9d9d9d', borderColor: '#9d9d9d'}}
    onClick={onClick}
  />
);

export const Copy = ({text, title}) => {
  const [copied, setCopy] = useState(false);

  return (
    <Action
      onClick={() => {
        navigator.clipboard.writeText(text);
        setCopy(true);
      }}
    >
      {copied && 'Copied!'}
      {!copied && (title ? title : <>Copy!</>)}
    </Action>
  );
};

export const ActionWithProgress = ({
  children,
  href = '',
  onClick = () => {},
  className = '',
  disabled = false,
  outline = false,
  loading = false,
  square = false,
  ...props
}) => {
  const [processing, setProcessing] = useState(false);

  let spinner = (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: outline ? '#04bbaf' : '#ffffff',
      }}
    >
      <Spinner size="sm" animation="border" />
    </div>
  );

  const buttonTextColor = outline ? '#04bbaf' : '#ffffff';
  const showSpinner = loading || processing;

  return (
    <Button
      disabled={disabled}
      className={className ? className : undefined}
      active={!showSpinner}
      style={{
        position: 'relative',
        backgroundColor: outline ? 'transparent' : '#04bbaf',
        borderColor: '#04bbaf',
        color: showSpinner ? `${buttonTextColor}80` : buttonTextColor,
        borderRadius: square ? '0' : undefined,
      }}
      onClick={async () => {
        setProcessing(true);
        try {
          await onClick?.();
        } finally {
          setProcessing(false);
        }
      }}
      href={href ? href : undefined}
      {...props}
    >
      {showSpinner ? spinner : null}
      {children}
    </Button>
  );
};

export const HelpWithProgress = ({
  children,
  href,
  onClick,
  className,
  disabled = false,
}) => {
  const [processing, setProcessing] = useState(false);

  let spinner = processing ? <Spinner size="sm" animation="border" /> : '';

  return (
    <Button
      className={className}
      variant={'outline-info'}
      disabled={disabled}
      active={!processing}
      onClick={async () => {
        setProcessing(true);
        try {
          await onClick();
        } finally {
          setProcessing(false);
        }
      }}
      href={href}
    >
      {spinner}
      {children}
    </Button>
  );
};
